import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.5 12.442a.752.752 0 0 1 0 1.12L12.67 15.2a.728.728 0 0 1-.5.19.711.711 0 0 1-.55-.25.747.747 0 0 1 .05-1.06l.37-.33H10a.75.75 0 0 1 0-1.5h2.05l-.38-.34a.747.747 0 0 1 1-1.11Zm-3.34-11.19H7.97a.75.75 0 0 0 0 1.5h3.19a2.087 2.087 0 0 1 2.09 2.08v2.63a.75.75 0 0 0 1.5 0v-2.63a3.585 3.585 0 0 0-3.59-3.58ZM12.75 5.6v2.8a2.354 2.354 0 0 1-2.35 2.35H3.6A2.354 2.354 0 0 1 1.25 8.4V5.6A2.347 2.347 0 0 1 3.6 3.252h6.8A2.347 2.347 0 0 1 12.75 5.6Zm-1.5 0a.849.849 0 0 0-.85-.85H3.6a.849.849 0 0 0-.85.85v2.8a.849.849 0 0 0 .85.85h6.8a.849.849 0 0 0 .85-.85ZM7 5.5A1.5 1.5 0 1 0 8.5 7 1.5 1.5 0 0 0 7 5.5Z';
const draw24px =
  'M15.86,17H5a2.75,2.75,0,0,1-2.75-2.75v-6A2.75,2.75,0,0,1,5,5.58H15.86a2.75,2.75,0,0,1,2.75,2.75v6A2.75,2.75,0,0,1,15.86,17ZM5,7.08A1.25,1.25,0,0,0,3.76,8.33v6A1.25,1.25,0,0,0,5,15.54H15.86a1.25,1.25,0,0,0,1.25-1.25v-6a1.25,1.25,0,0,0-1.25-1.25Zm16.73,5.79V7.44a5,5,0,0,0-5-5H10a.75.75,0,0,0,0,1.5h6.75a3.5,3.5,0,0,1,3.49,3.5v5.43a.75.75,0,1,0,1.5,0ZM10.43,8.93a2.38,2.38,0,1,0,2.38,2.38A2.38,2.38,0,0,0,10.43,8.93ZM22.48,19l-2.73-2.45a.75.75,0,1,0-1,1.11L20,18.79H16a.75.75,0,0,0,0,1.5h4l-1.28,1.15a.75.75,0,0,0-.06,1.06.75.75,0,0,0,1.06.06l2.73-2.46a.75.75,0,0,0,.25-.56A.77.77,0,0,0,22.48,19Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const MoneyArrowOutIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'moneyArrowOut')) as IconWithRender;

MoneyArrowOutIcon.displayName = 'MoneyArrowOutIcon';
MoneyArrowOutIcon.propTypes = Icon.propTypes;
MoneyArrowOutIcon.renderIcon = (props) => <MoneyArrowOutIcon {...props} />;
export default MoneyArrowOutIcon;
